import { Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { ApiService } from '../api-services/api.service';
import {
  CalendarEvent,
  Place,
  PlaceAvatar,
  PlaceAvatarStorage,
} from 'src/app/interfaces/interfaces';
import { Observable, take, map, firstValueFrom, tap, catchError, of } from 'rxjs';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class AvatarService {
  storageKey: string = 'avatars';
  constructor(private apiService: ApiService) {}

  avatarList : WritableSignal<PlaceAvatar[]> = signal<PlaceAvatar[]>([]);

  fetchAvatarsForPlaces() {
    let loadedAvatars = this.loadAvatars();
    if (loadedAvatars == null) {
    return firstValueFrom(this.apiService.getAvatarlacesForPlaces().pipe(
      tap((avatars) => {
        this.avatarList.set(avatars);
        this.saveAvatars(avatars);
      }),
      catchError((error) => {
        console.error('Error fetching avatars', error);
        return of([]);
      })
    ));
    } else {
      this.avatarList.set(loadedAvatars);
    }
  }

  private saveAvatars(avatars: PlaceAvatar[]) {
    let dataToSav: PlaceAvatarStorage = {
      avatars: avatars,
      savedAt: moment().toISOString(),
    };
    localStorage.setItem(this.storageKey, JSON.stringify(dataToSav));
  }

  private loadAvatars(): PlaceAvatar[] {
    let loadedData: PlaceAvatarStorage = JSON.parse(
      localStorage.getItem(this.storageKey)
    );
    if (
      loadedData &&
      moment().isBefore(moment(loadedData.savedAt).add(7, 'days'))
    ) {
      return loadedData.avatars;
    }
    return null;
  }

  public resetAvatarData() {
    this.avatarList.set([]);
    localStorage.removeItem(this.storageKey);
  }
}
